<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12>
                <month-picker @newData="handleData($event)"></month-picker>
            </v-flex>
            <v-flex xs12>
                <!-- Billing stats -->
                <v-container fluid class="pa-0">
                    <v-layout column wrap>
                        <v-flex xs12>
                            <v-card>
                                <v-card-title primary-title class="pt-3">
                                    <div class="display-1 mb-0 mt-0">Billing for month</div>
                                </v-card-title>
                                <v-card-text>
                                    <div class="headline">
                                        Events: {{ total_events }}
                                    </div>
                                    <div class="headline">
                                        Total billing: {{ total_events }}
                                    </div>
                                    <div class="headline">
                                        Billed: {{ total_events }}
                                    </div>
                                    <div class="headline">
                                        Unbilled: {{ total_events }}
                                    </div>
                                    <div class="headline">
                                        Expenses: {{ total_events }}
                                    </div>
                                    <div class="headline">
                                        Profit: {{ total_billing - total_expenses }}
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import MonthPicker from './MonthPicker.vue'

export default {
    name: "DashboardOverview",
    data () {
    return {
        ws_channel: undefined,
        events: undefined,
        filters: {
            daterange: {
                start: 0,
                end: 0
            }
        },
        total_events: 0,
        total_billing: 0.0,
        total_billed: 0.0,
        total_unbilled: 0.0,
        total_expenses: 0.0,
    }
    },
    components: {
        MonthPicker
    },
    mounted () {
        this.connect_ws();
    },
    beforeDestroy () {
        this.ws_channel.leave();
    },
    watch: {
        filters: {
            handler: function() {
                if (this.ws_channel) {
                    this.filter_events();
                }
            },
            deep: true
        }
    },
    computed: {},

    methods: {
        handleData(e) {
            this.filters.daterange.start = e[0];
            this.filters.daterange.end = e[1];
            console.log(this.filters);
        },
        connect_ws () {
            var self = this;
            this.ws_channel = this.$socket.channel("events:all");
            this.ws_channel.on("init", function(msg) {
                self.get_events();
            });
            this.ws_channel.on("events", function(msg) {
                self.events = msg.events;
                console.log(self.events);
                filter_events();
            });
            this.ws_channel.on("event-update", function(msg) {
                self.get_events();
            });
            this.ws_channel.join();
        },
    }
}
</script>